'use client';
import styled from 'styled-components';

import { ListingForLandingViewModel } from '@api/index';
import PopularCities from '@components/views/flight/landing/components/popular-cities/PopularCities';
import { SizeUnit } from '@utils/types';

const Container = styled.div<{ marginTop?: SizeUnit }>`
  display: grid;
  grid-template-columns: repeat(3, 360px);
  justify-content: space-between;
  margin-top: ${(props) => (props.marginTop ? props.marginTop : '0px')};

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    overflow-x: scroll;
    overflow-y: hidden;
    grid-template-columns: repeat(3, 320px);
    grid-gap: 20px;
  }
`;

const PopularCitiesContainer = ({
  data,
  marginTop = '0px',
}: {
  data: ListingForLandingViewModel[];
  marginTop?: SizeUnit;
}) => {
  return (
    <Container marginTop={marginTop}>
      {data?.map((item) => (
        <PopularCities
          key={item?.boldTitle}
          items={item?.links}
          label={item?.boldTitle || ''}
          image={item?.images?.[0]?.url || ''}
          slug={item?.slug}
        />
      ))}
    </Container>
  );
};

export default PopularCitiesContainer;
